export default function HeroClockIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="79"
      height="79"
      fill="none"
      viewBox="0 0 79 79"
    >
      <rect
        width="78.712"
        height="78.712"
        x=".151"
        y=".02"
        fill="#E0EEFE"
        rx="39.356"
      />
      <path
        fill="#0070F4"
        d="M39.496 61.498c-8.082 0-15.462-4.217-19.503-11.244-4.04-6.94-4.04-15.462 0-22.49 4.041-6.94 11.42-11.244 19.503-11.244 7.994 0 15.373 4.305 19.414 11.245 4.041 7.027 4.041 15.549 0 22.489-4.041 7.027-11.42 11.244-19.414 11.244Zm2.108-34.436c0-1.142-.966-2.109-2.108-2.109-1.23 0-2.109.967-2.109 2.109v11.947c0 .79.352 1.493 1.054 1.933.703.351 1.494.263 2.197-.176l8.433-5.622c.966-.615 1.23-1.933.615-2.9-.703-.965-2.02-1.23-2.987-.614l-5.095 3.514v-8.082Z"
      />
    </svg>
  )
}
